// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dropzone {\n  width: 150px;\n  height: 150px;\n  border: 1px dashed #ced4da !important;\n}\n.dropzone .dz-message {\n  margin: 1em 0;\n}\n.dropzone .dz-message {\n  font-size: 16px !important;\n}\n.dropzone .dz-message {\n  color: #ced4da;\n  margin: 27px 0 !important;\n}\n.dropzone .dz-preview {\n  margin: -6px;\n}", ""]);
// Exports
module.exports = exports;
